'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: 'Zeit auswählen'
};

exports['default'] = locale;